export const types = {
    CAPTURE: 'DCAPTURE',
    CLICK: 'CLICK',
    FCLICK: 'FIND-AND-CLICK',
    FINPUT: 'FIND-AND-INPUT',
    SCOPE: 'SCOPE',
    GETTEXT: 'GET-TEXT',
    GETIMAGE: 'GET-IMAGE',
    MOVE: 'MOUSE-MOVE',
    WAIT: 'WAIT',
    DCLICK: 'DOUBLE-CLICK',
    DRAG: 'MOUSE-DRAG',
    SDOWN: 'SCROLL-DOWN',
    SUP: 'SCROLL-UP',
    PRESS: 'KEY-PRESS',
    TAP: 'KEY-TAP',
    COMBINATION: 'KEY-COMBINATION',
    HOVER: 'HOVER'
};
